/**
 * Action for Fetch FSM list details
 */
export enum getFSMList {
  FETCH_FSM_LIST_REQUEST = 'FETCH_FSM_LIST_REQUEST',
}
